import { FC } from 'react';
import s from './storeItem.module.scss';
import { Avatar } from '@components/UIKit/Avatar/Avatar';
import { Currency } from '@components/UIKit/Currency/Currency';
import { Button } from '@components/UIKit/Button/Button';
import { StoreItemView } from '@services/store/views';
import { useGetPublicProfile } from '@hooks/TRPC_Hooks/useGetPublicProfile';
import cn from 'classnames';
import { useToysCart } from '@hooks/useToysCart';
import { StoreItemLoading } from '@components/Cards/StoreItem/StoreItemLoading';
import { useShowToast } from '@hooks/useShowToast';
import { useTranslation } from '@hooks/useTranslation';
import { toy } from '@specs/specs';
import { useSession } from 'next-auth/react';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
interface Props extends Omit<StoreItemView, 'instanceid'> {
  instanceid: NonNullable<StoreItemView['instanceid']>;
  toyName: toy['name'];
}
export const StoreItem: FC<Props> = props => {
  const {
    status
  } = useSession();
  const {
    translate: tr
  } = useTranslation();
  const {
    showToast
  } = useShowToast();
  const {
    currency,
    price,
    ownership,
    toyid,
    instanceid,
    toyName
  } = props;
  const {
    addToCartHandler,
    isInCartState
  } = useToysCart({
    toyId: toyid ?? -1,
    instanceId: instanceid
  });
  const {
    data: myProfile,
    isLoading: myProfileLoading
  } = useProfile();
  const {
    data: profile,
    isLoading: profileLoading
  } = useGetPublicProfile({
    shortId: ownership?.profile?.shortid ?? ''
  }, {
    enabled: typeof ownership?.profile?.shortid === 'string'
  });
  const clickHandler = async () => {
    if (isInCartState) return;
    const result = addToCartHandler(props);
    if (result) {
      showToast({
        variant: 'info',
        title: tr({
          id: 'toy.page.added.to.cart.title'
        }, {
          name: toyName
        }),
        text: 'toy.page.added.to.cart.description',
        icon: {
          name: 'cart'
        }
      });
    }
  };
  const isLoading = typeof ownership?.profile?.shortid === 'string' && profileLoading || status === 'authenticated' && myProfileLoading;
  if (isLoading) return <StoreItemLoading />;
  if (!profile) return null;
  const {
    shortid
  } = profile;
  return <div className={s.storeItem} data-sentry-component="StoreItem" data-sentry-source-file="StoreItem.tsx">
            <Avatar srcSet={[{
      height: 40,
      width: 40,
      minMedia: 0
    }]} profile={profile} isLoading={isLoading} data-sentry-element="Avatar" data-sentry-source-file="StoreItem.tsx" />
            <div className={s.storeItem__main}>
                <div className={cn(s.storeItem__name, '_ellipsis')}>{shortid}</div>
                <div className={cn(s.storeItem__instanceId, '_ellipsis')}>
                    #{instanceid}
                </div>
            </div>
            <div className={s.storeItem__right}>
                <Currency currency={currency} amount={price} data-sentry-element="Currency" data-sentry-source-file="StoreItem.tsx" />
                <Button id={isInCartState ? 'store_item_check_button' : 'store_item_cart_button'} color={'White'} size={'small'} onClick={clickHandler} disabled={status !== 'authenticated' || myProfile?.shortid === shortid} icons={{
        left: {
          name: isInCartState ? 'check' : 'cart'
        }
      }} data-sentry-element="Button" data-sentry-source-file="StoreItem.tsx" />
            </div>

        </div>;
};